import { render, staticRenderFns } from "./NotLoginLayout.vue?vue&type=template&id=6d42c29d&scoped=true&"
var script = {}
import style0 from "./NotLoginLayout.vue?vue&type=style&index=0&id=6d42c29d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d42c29d",
  null
  
)

export default component.exports